import Vue from 'vue';
import draggable from 'vuedraggable'
import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import { PROJECT_COMMONS } from '../../values/sections';
import { SectionsProvider } from '../../providers/sections.provider';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';
import EdSectionProjects from '@/courses/components/ed-section-projects/ed-section-projects.vue';
import { ProjectsMixin } from '@/courses/mixins/projects.mixin';
import { ContentType } from '@/content/types/content.types';

@Component({
  name: 'ed-section-projects-tree',
  components: {
    draggable,
    EdSectionProjects
  }
})
class EdSectionProjectsTree extends Mixins(ProjectsMixin, CourseToolsMixin) {

  /* Props */
  @Prop() readonly groupName: string;
  @Prop() readonly className: string;
  @Prop() readonly parentId: number;
  @Prop({ default: 'SUBJECT' }) readonly contentType: ContentType;

  /* Data */
  public group: any = { name: PROJECT_COMMONS.PROJECT_LIST };
  public classV: any = '';
  public menuOptions: any[] = [];

  /* Computed */
  get projectList() {
    let projects = [];
    projects = this.course.projects;
    if (this.parentId) {
      let project = SectionsProvider.getProjectByID(projects, this.parentId);
      return project ? project.projects : [];
    } else {
      return projects;
    }
  }

  set projectList(projects) {
    this.$Courses.Store.updateOrderProjects({
      projects,
      projectId: this.parentId,
      courseId: this.courseID,
      classId: this.classID
    })
  }

  sectionMoved(e) {
    this.$Courses.Store.setMovingObject(false);
    if(e.added) {
      this.$Courses.Store.reorderProjectA({
        project: e.added.element,
        parentId: this.parentId || -1,
        place:  e.added.newIndex == 0 ? -1 : this.projectList[e.added.newIndex] ? this.projectList[e.added.newIndex].projectId : -1,
        courseId: this.courseID
      });
    }
    if(e.moved) {
      this.$Courses.Store.reorderProjectA({
        project: e.moved.element,
        parentId: this.parentId || -1,
        place:  e.moved.newIndex == 0 ? -1 : this.projectList[(e.moved.newIndex - 1)] ? this.projectList[(e.moved.newIndex - 1)].projectId : this.projectList[e.moved.newIndex].projectId,
        courseId: this.courseID
      });
    }
  }

  created() {
    this.group = this.groupName ? this.groupName : PROJECT_COMMONS.PROJECT_LIST;
    this.classV = this.className ? this.className : PROJECT_COMMONS.PROJECT_PARENT_LIST;
  }
}

export default Vue.component('ed-section-projects-tree', EdSectionProjectsTree)